var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgControl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2.16506C18.9517 1.18258 21.0483 1.18258 22.75 2.16506L34.0705 8.70096C35.7722 9.68344 36.8205 11.4991 36.8205 13.4641V26.5359C36.8205 28.5009 35.7722 30.3166 34.0705 31.299L22.75 37.8349C21.0483 38.8174 18.9517 38.8174 17.25 37.8349L5.92949 31.299C4.22779 30.3166 3.17949 28.5009 3.17949 26.5359V13.4641C3.17949 11.4991 4.22779 9.68344 5.92949 8.70096L17.25 2.16506Z",
    fill: "url(#paint0_linear_994_11161)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2.16506C18.9517 1.18258 21.0483 1.18258 22.75 2.16506L34.0705 8.70096C35.7722 9.68344 36.8205 11.4991 36.8205 13.4641V26.5359C36.8205 28.5009 35.7722 30.3166 34.0705 31.299L22.75 37.8349C21.0483 38.8174 18.9517 38.8174 17.25 37.8349L5.92949 31.299C4.22779 30.3166 3.17949 28.5009 3.17949 26.5359V13.4641C3.17949 11.4991 4.22779 9.68344 5.92949 8.70096L17.25 2.16506Z",
    stroke: "white",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4001 12H24.2667C23.972 12 23.7334 12.2386 23.7334 12.5333C23.7334 12.8281 23.972 13.0667 24.2667 13.0667H26.4001C26.6945 13.0667 26.9334 13.3056 26.9334 13.6V14.6667C26.9334 14.9614 27.172 15.2 27.4667 15.2C27.7615 15.2 28.0001 14.9614 28.0001 14.6667V13.6C28.0001 12.7179 27.2826 12 26.4001 12Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7333 12H13.6C12.7179 12 12 12.7179 12 13.6V14.6667C12 14.9614 12.2386 15.2 12.5333 15.2C12.8281 15.2 13.0667 14.9614 13.0667 14.6667V13.6C13.0667 13.3056 13.3056 13.0667 13.6 13.0667H15.7333C16.0281 13.0667 16.2667 12.8281 16.2667 12.5333C16.2667 12.2386 16.0281 12 15.7333 12Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7333 26.9333H13.6C13.3056 26.9333 13.0667 26.6944 13.0667 26.4V25.3333C13.0667 25.0386 12.8281 24.8 12.5333 24.8C12.2386 24.8 12 25.0386 12 25.3333V26.4C12 27.2821 12.7179 28 13.6 28H15.7333C16.0281 28 16.2667 27.7614 16.2667 27.4667C16.2667 27.1719 16.0281 26.9333 15.7333 26.9333Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4667 24.8C27.172 24.8 26.9334 25.0386 26.9334 25.3333V26.4C26.9334 26.6944 26.6945 26.9333 26.4001 26.9333H24.2667C23.972 26.9333 23.7334 27.1719 23.7334 27.4667C23.7334 27.7614 23.972 28 24.2667 28H26.4001C27.2822 28 28.0001 27.2821 28.0001 26.4V25.3333C28.0001 25.0386 27.7615 24.8 27.4667 24.8Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9468 18.6918C26.2272 20.6773 25.3855 22.655 23.7554 23.842C21.0265 25.8382 21.09 27 20.4978 27C19.9056 27 19.9647 25.8256 17.2442 23.8463C14.7961 22.0633 14.2694 18.6509 16.0681 16.2242C17.8665 13.7979 21.3089 13.2758 23.7569 15.0588C24.9504 15.9282 25.7401 17.2378 25.9468 18.6918Z",
    fill: "url(#paint1_linear_994_11161)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 23.0002C22.433 23.0002 24 21.4332 24 19.5002C24 17.5672 22.433 16.0002 20.5 16.0002C18.567 16.0002 17 17.5672 17 19.5002C17 21.4332 18.567 23.0002 20.5 23.0002Z",
    fill: "#562F76"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_994_11161",
    x1: 18.0556,
    y1: 21.1111,
    x2: 6.94445,
    y2: 33.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C441F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_994_11161",
    x1: 20.4821,
    y1: 26.9329,
    x2: 20.4821,
    y2: 13.9278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0C0F3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControl);
export default __webpack_public_path__ + "static/media/control.24124a6af1865f2ff9f29531ed063c41.svg";
export { ForwardRef as ReactComponent };